module.exports = "https://static.zego.com/_next/static/images/CustomerService2-2f9fc7b62946ebff7ca50b188cf28e00.jpg";